<template>
  <div class="home">
    <Message :key="key" :msg="msgMd" />
    <MessageList />
  </div>
</template>

<script>
// @ is an alias to /src
import { getUserMessages } from "@/gateway";
import MessageList from "@/components/MessageList.vue";
import Message from "@/components/Message.vue";
export default {
  name: "home",
  components: {
    Message,
    MessageList
  },
  data() {
    return {
      dataLoaded: false,
      msgMd: "asd",
      key: "addf"
    };
  },
  methods: {
    async getMessage() {
      var response = await getUserMessages();

      this.msgMd = response.htmlMessage;
      this.msgMd = "am a ~~tast~~ **test**.";
      this.msgMd = response.htmlMessage;
      this.key = response.htmlMessage;
      this.dataLoaded = true;
    }
  },
  mounted: function() {
    this.getMessage();
  }
};
</script>
